import { PageController } from '@client/components/_core/layout/PageController';
import { ClaimStatusEdit } from '@client/components/claims/ClaimStatusEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add')(
    {
        staticData: {
            presentation: 'overlay',
            metadata: {
                title: 'New claim status',
            },
        },
        component: RouteComponent,
    },
);

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ClaimStatusEdit action={['add']} />
        </PageController>
    );
}
